import EditableDetailPanel from 'Components/Generic/DetailPanel/EditableDetailPanel';
import LineItemList from 'Components/Generic/LineItems/LineItemList';
import PropTypes from 'prop-types';
import { useState } from 'react';

const LineItemsPanel = ({
  title = 'Line Items',
  editable = false,
  disabled = false,
  isNew = false,
  ...props
}) => {
  const [editState, setEditState] = useState(undefined);
  return (
    <EditableDetailPanel
      title={title}
      editable={editable}
      disabled={disabled}
      hideToggle={isNew}
      renderChild={(inEditState) => {
        return (
          <LineItemList
            {...props}
            setEditState={setEditState}
            editable={inEditState}
            isNew={isNew}
          />
        );
      }}
      parentEditState={isNew || editState}
    />
  );
};

LineItemsPanel.propTypes = {
  title: PropTypes.string,
  request: PropTypes.shape({ line_items: PropTypes.array }),
  transaction: PropTypes.shape({
    line_items: PropTypes.array,
  }),
  editable: PropTypes.bool,
  onUpdateLineItems: PropTypes.func,
  disabled: PropTypes.bool,
  isNew: PropTypes.bool,
};

export default LineItemsPanel;
